import { EnsuredReferenceObserver } from "./EnsuredReferenceObserver.js";
/**
 * Creates an observer to proxy a subscriber reference.
 *
 * @remarks
 *
 * Effectively ensures that an optional subscriber
 * always exists and is subscribed to the consuming observable.
 */
export function unwrapSubscriber(input) {
    return new EnsuredReferenceObserver(input);
}
